import { Navigate, useParams } from 'react-router';

import { NotFoundPage } from '@/app/shell/NotFoundPage';
import { incidentDetailRoute } from '@/features/shared/routes';
import { parseLegacyIncidentId } from './legacyUrls';

export function LegacyIncidentRedirect() {
  const { id } = useParams();
  const incidentId = parseLegacyIncidentId(id);

  if (incidentId === null) {
    return <NotFoundPage />;
  }

  return <Navigate to={incidentDetailRoute(incidentId)} replace />;
}
